import React from "react";
import { SkeletonLoader, SkeletonUnit } from "../../../../SkeletonLoader";
import { size } from "./../../../../../shared/constants";
import * as S from "./../../styles";
export default function ButtonsContent(_ref) {
  var e = _ref.topLevelLinks,
      t = _ref.accountLinks,
      n = _ref.loggedIn,
      a = _ref.isLoggingIn;
  return !0 === a ? React.createElement(SkeletonLoader, {
    height: {
      value: Number(size.xl3),
      unit: SkeletonUnit.Pixel
    },
    width: {
      value: 100,
      unit: SkeletonUnit.Percentage
    },
    testId: "skeleton-loader"
  }) : React.createElement(React.Fragment, null, e.register && React.createElement(S.Button, {
    href: e.register.url,
    appearance: "primary",
    "data-testid": "mobile-register-link"
  }, e.register.label), !n && t.login && React.createElement(S.Button, {
    href: t.login.url,
    appearance: "secondary",
    "data-testid": "mobile-login-link"
  }, t.login.label), n && t.account && React.createElement(S.Button, {
    href: t.account.hub.url,
    appearance: "secondary"
  }, t.account.hub.label));
}